module.exports = __webpack_public_path__ + "img/logo_dms.e63ea1c6.png";